

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBYstCjHXFbHZMvtW8cqbt6qkDiYgROI5w",
  authDomain: "resume-15a3c.firebaseapp.com",
  projectId: "resume-15a3c",
  storageBucket: "resume-15a3c.appspot.com",
  messagingSenderId: "27092047395",
  appId: "1:27092047395:web:abe29e65be5260ec53c396",
  measurementId: "G-LVDD68SVEG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAnalytics(app);
export { app, auth };